/** "3h ago", "2d ago" — the short relative form used in the notification bell. */
export function timeAgo(value) {
    if (!value) return "";
    const then = new Date(value).getTime();
    if (Number.isNaN(then)) return "";

    const seconds = Math.floor((Date.now() - then) / 1000);
    if (seconds < 60) return "just now";

    const units = [
        ["y", 31536000],
        ["mo", 2592000],
        ["w", 604800],
        ["d", 86400],
        ["h", 3600],
        ["m", 60],
    ];

    for (const [label, secs] of units) {
        const n = Math.floor(seconds / secs);
        if (n >= 1) return `${n}${label} ago`;
    }
    return "just now";
}

/** "14 Jul 2026" — the date shown on cards and detail pages. */
export function formatDate(value) {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}
